if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        const isQuickShop = new URLSearchParams(window.location.search).get('quick_shop') === 'true' || this.querySelector('.merch-quick-shop-btn');
        if (isQuickShop) {
          this.initQuickShop();
        } else {
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        }

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      initQuickShop() {
        // Hide dynamic checkout buttons (Buy it Now) on page forms
        const buyNowBtn = document.querySelector('.shopify-payment-button') || document.querySelector('[data-shopify~="payment-button"]');
        if (buyNowBtn && !this.closest('.card') && !this.closest('.card-wrapper')) {
          buyNowBtn.style.setProperty('display', 'none', 'important');
        }

        // Change submit button submit handler
        this.form.addEventListener('submit', this.onQuickShopSubmit.bind(this));

        // Listen for variant change
        this.variantIdInput.addEventListener('change', () => {
          this.syncQuickShopState();
        });

        // Get custom quantity selector elements
        const productId = this.dataset.productId;
        const selector = document.getElementById(`QuickShopQtySelector-${productId}`);
        if (selector) {
          const plusBtn = selector.querySelector('.plus');
          const minusBtn = selector.querySelector('.minus');

          plusBtn.addEventListener('click', (e) => {
            e.preventDefault();
            const currentQty = parseInt(selector.querySelector('.quick-shop-qty-value').textContent) || 0;
            this.updateCartQuantity(currentQty + 1);
          });

          minusBtn.addEventListener('click', (e) => {
            e.preventDefault();
            const currentQty = parseInt(selector.querySelector('.quick-shop-qty-value').textContent) || 0;
            if (currentQty > 0) {
              this.updateCartQuantity(currentQty - 1);
            }
          });
        }

        // Initialize state on load
        this.syncQuickShopState();
      }

      syncQuickShopState() {
        const variantId = this.variantIdInput.value;
        if (!variantId) return;

        fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            const item = cart.items.find(item => item.id == variantId || item.variant_id == variantId);
            const qty = item ? item.quantity : 0;

            const productId = this.dataset.productId;
            const selector = document.getElementById(`QuickShopQtySelector-${productId}`);
            if (selector) {
              const valueSpan = selector.querySelector('.quick-shop-qty-value');
              valueSpan.textContent = qty;
              if (qty > 0) {
                selector.style.display = 'inline-flex';
              } else {
                selector.style.display = 'none';
              }
            }

            if (qty > 0) {
              this.submitButtonText.textContent = 'Add more';
            } else {
              this.submitButtonText.textContent = 'Quick Buy';
            }
          })
          .catch(e => console.error('Error syncing quick shop state:', e));
      }

      updateCartQuantity(newQty) {
        const variantId = this.variantIdInput.value;
        if (!variantId) return;

        const productId = this.dataset.productId;
        const selector = document.getElementById(`QuickShopQtySelector-${productId}`);
        const plusBtn = selector?.querySelector('.plus');
        const minusBtn = selector?.querySelector('.minus');
        const valueSpan = selector?.querySelector('.quick-shop-qty-value');

        if (plusBtn) plusBtn.disabled = true;
        if (minusBtn) minusBtn.disabled = true;
        if (valueSpan) valueSpan.style.opacity = '0.5';

        const config = fetchConfig('javascript');
        config.headers['Content-Type'] = 'application/json';
        
        const bodyData = {
          id: String(variantId),
          quantity: newQty
        };

        if (this.cart) {
          bodyData.sections = this.cart.getSectionsToRender().map((section) => section.id);
          bodyData.sections_url = window.location.pathname;
        }

        config.body = JSON.stringify(bodyData);

        fetch('/cart/change.js', config)
          .then(response => response.json())
          .then(cart => {
            if (plusBtn) plusBtn.disabled = false;
            if (minusBtn) minusBtn.disabled = false;
            if (valueSpan) valueSpan.style.opacity = '1';

            const item = cart.items.find(item => item.id == variantId || item.variant_id == variantId);
            const actualQty = item ? item.quantity : 0;

            if (valueSpan) valueSpan.textContent = actualQty;

            if (actualQty > 0) {
              if (selector) selector.style.display = 'inline-flex';
              this.submitButtonText.textContent = 'Add more';
            } else {
              if (selector) selector.style.display = 'none';
              this.submitButtonText.textContent = 'Quick Buy';
            }

            // Sync with standard cart drawer
            if (this.cart) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: variantId,
                cartData: cart,
              }).then(() => {
                this.cart.renderContents(cart);
              });
            }
          })
          .catch(e => {
            console.error('Error updating cart quantity:', e);
            if (plusBtn) plusBtn.disabled = false;
            if (minusBtn) minusBtn.disabled = false;
            if (valueSpan) valueSpan.style.opacity = '1';
          });
      }

      onQuickShopSubmit(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();
        this.submitButton.setAttribute('aria-disabled', true);

        // Transition: "Adding to cart..." with animating dots
        const originalText = this.submitButtonText.innerHTML;
        this.submitButtonText.innerHTML = 'Adding to cart<span class="anim-dots"><span class="dot-1">.</span><span class="dot-2">.</span><span class="dot-3">.</span></span>';

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        // Force quantity to 1 for quick buy addition
        formData.set('quantity', 1);

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        const startTime = Date.now();

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              this.submitButtonText.innerHTML = originalText;
              this.submitButton.removeAttribute('aria-disabled');
              return;
            }

            // Enforce that "Adding to cart..." is visible for at least 1.5s
            const elapsedTime = Date.now() - startTime;
            const remainingTime = Math.max(0, 1500 - elapsedTime);

            setTimeout(() => {
              // Transition: Shimmer effect
              this.submitButtonText.classList.add('shimmer-text');
              this.submitButtonText.innerHTML = 'Adding to cart...';

              setTimeout(() => {
                // Transition: "Added"
                this.submitButtonText.classList.remove('shimmer-text');
                this.submitButtonText.innerHTML = 'Added';

                // Sync UI and show quantity selector next to price
                this.syncQuickShopState();

                setTimeout(() => {
                  // Transition: "Add more"
                  this.submitButtonText.innerHTML = 'Add more';
                  this.submitButton.removeAttribute('aria-disabled');
                }, 1500);

              }, 1000); // Shimmer runs for 1 second

            }, remainingTime);

            // Sync with standard cart drawer
            if (this.cart) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
            this.submitButtonText.innerHTML = originalText;
            this.submitButton.removeAttribute('aria-disabled');
          });
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
